import { threeDot } from "helper/icons";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

const ThreeDotMenu = (props) => {
  const {
    dynamicHeight,
    options,
    width = "w-[240px]",
    onSelectOption,
    toggleComponent,
    threeDotWidth = "",
    fromUser = false,
    onClickDot,
  } = props || {};

  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0, width: 0 });
  const buttonRef = useRef(null);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = (event) => {
    event.stopPropagation();
    if (!isOpen && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY,
        left: rect.left + rect.width / 3 + window.scrollX,
        width: rect.width,
      });
    }
    setIsOpen(!isOpen);
  };

  const selectOption = (option) => {
    setIsOpen(false);
    onSelectOption?.(option);
  };

  return (
    <div className="relative inline-block text-left">
      <div
        ref={buttonRef}
        className={`inline-flex items-center justify-center cursor-pointer ${threeDotWidth}`}
        onClick={(e) => toggleMenu(e)}
      >
        {toggleComponent ?? (
          <img onClick={onClickDot} src={threeDot} alt="" />
        )}
      </div>

      {isOpen &&
        createPortal(
          <div
            ref={dropdownRef}
            className={`absolute z-50 bg-white rounded-md shadow-100 ${
              !dynamicHeight ? "h-[185px]" : ""
            } ${options.length > 3 ? "overflow-y-scroll" : ""} ${width}`}
            style={{
              position: "absolute",
              top: position.top,
              left: position.left,
              transform: "translateX(-80%)",
            }}
          >
            <div
              className="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {options?.map((option, index) => (
                <button
                  key={option}
                  onClick={(event) => {
                    event.stopPropagation();
                    selectOption(option);
                  }}
                  className={`block w-full text-left px-4 py-4 text-sm text-gray-700 hover:bg-primary/50 hover:text-white ${
                    index !== options.length - 1 ? "border-b border-purple-100" : ""
                  } border-gray-200`}
                  role="menuitem"
                >
                  {option}
                </button>
              ))}
            </div>
          </div>,
          document.body
        )}
    </div>
  );
};

export default ThreeDotMenu;
